import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SessionService} from "../common/session/session.service";
import {ExhitorsService} from "../exhitors/exhitors.service";

@Component({
  selector: 'app-card-note',
  templateUrl: './card-note.component.html',
  styleUrls: ['./card-note.component.css']
})
export class CardNoteComponent implements OnInit, OnDestroy {
  @Input() item: any = {};
  @Input() selectedView: string = '';
  eventData: any = null;

  constructor(private sessionService: SessionService, private exhibitorSvc: ExhitorsService) {
  }

  saveNote(item: any, event: Event) {
    event.stopPropagation();

    let endpoint = 'Exhibitor';
    let entityId =  item.exhibitorId || item.entityId;
    let id = item.favoriteId || item.id;

    let saveNoteIn = {
      eventName: this.eventData.eventName,
      id: id,
      note: item.note
    };

    if (item.type === 'PRODUCT') {
      endpoint = 'Product';
      entityId = item.idProduct || item.entityId;
    }

    saveNoteIn['id'+ endpoint] = entityId;

    if(item.type === 'PRODUCT'){
      this.exhibitorSvc.editFavoriteProduct(saveNoteIn).subscribe(res => {
        item.showNote = false;
      }, err => {
        console.warn(err);
      });
    } else {
      this.exhibitorSvc.editFavoriteExhibitor(saveNoteIn).subscribe(res => {
        item.showNote = false;
      }, err => {
        console.warn(err);
      });
    }

  }

  closeNote(item: any, event: Event) {
    event.stopPropagation();
    item.showNote = false;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  removeNote(item: any, event: Event) {
    item.note = '';
    this.saveNote(item, event);
  }

  ngOnDestroy() {
  }

  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

  }
}
